import { render, staticRenderFns } from "./OssReactionsCount.vue?vue&type=template&id=394751bf&scoped=true"
import script from "./OssReactionsCount.vue?vue&type=script&lang=js"
export * from "./OssReactionsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394751bf",
  null
  
)

export default component.exports